export default __webpack_public_path__ + "static/media/conditionalRenderingReact_blog.13ca7900.png";